<template>
  <collapsible-fixed-footer :expanded="expanded" @update:expanded="$emit('update:expanded', $event)">
    <slot />
    <template #collapse-button-label><slot name="collapse-button-label" /></template>
    <template #expand-button-label><slot name="expand-button-label" /></template>
  </collapsible-fixed-footer>

</template>

<script>
import { CollapsibleFixedFooter } from "@springbig/sb-components";

export default {
  name: 'AutosizedCollapsibleFooter',
  components: {
    CollapsibleFixedFooter
  },
  props: {
    expanded: Boolean
  },
  async created() {
    this.$nextTick(()=>{
      // Keeps the drawer fixed at the right position when resizing or scrolling the window
      window.addEventListener('scroll', this.updateDrawerPosition);
      window.addEventListener('resize', this.updateDrawerPosition);
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.updateDrawerPosition);
    window.removeEventListener('resize', this.updateDrawerPosition);
  },
  methods: {
    updateDrawerPosition() {
      const drawer = document.querySelector('.collapsible-display');
      if(!drawer) return;

      const viewportWidthNoScrollbar = window.innerWidth;
      const viewportWidth = document.body.clientWidth;
      if(viewportWidthNoScrollbar >= 1024) {
        const scrollX = window.scrollX;
        const drawerLeft = 270 - scrollX;
        drawer.style.maxWidth = 'none';
        drawer.style.width = (viewportWidth-drawerLeft) + "px";
        drawer.style.left = drawerLeft + "px";
      }else{
        drawer.style.removeProperty('maxWidth')
        drawer.style.removeProperty('width')
        drawer.style.removeProperty('left')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collapsible-display {
  right: 0;
  margin: 0;
  max-width: calc(100% - 270px);
  left:auto;
  z-index:9;
}
@media only screen and (max-width: 1023px) {
  .collapsible-display {
    width: 100%;
    max-width: none;
  }
}
.collapsible-display::v-deep ::-webkit-scrollbar { width: 5px; height: 5px }
.collapsible-display::v-deep ::-webkit-scrollbar-thumb { background: #a6d4fc; }
</style>
